/*
 * Session-wide state behind `useVendorNames`, kept in a module with NO imports so
 * the test setup can reset it without loading (and so un-mocking) the API client.
 *
 * Shared by every screen for the life of the tab, so going Dashboard → Queue →
 * Dashboard does not ask D365 about the same vendors again. A name is cached for
 * the session: vendor renames are rare and a reload picks them up.
 */
export const knownNames = new Map<string, string>();
/** Vendors D365 answered "no such vendor in that company" for — asking again cannot help. */
export const knownMissing = new Set<string>();
export const inFlight = new Map<string, Promise<string | null>>();
export const lookupQueue = { running: 0, waiting: [] as (() => void)[] };

/** The module state outlives a render, so tests must start each case clean. */
export function resetVendorNameCache(): void {
  knownNames.clear();
  knownMissing.clear();
  inFlight.clear();
  lookupQueue.waiting.length = 0;
  lookupQueue.running = 0;
}
